import styled from 'styled-components'
import media from 'styled-media-query'

import { customMedia } from '../../../../../utils/breakpoints';

export const MenuMobile = styled.ul`
  background-color: ${props => props.theme.colors.white};
  position: relative;
  top: 0;
  box-sizing: border-box;
  overflow: scroll;
  height: 100vh;
  margin: 0;
  padding: 0 2.4rem;
  z-index: 4;
  

  li:nth-child(4) {
    border-top: 1px solid #E5E5E5;
  }

  ${customMedia.greaterThan('md')`
    display: none;
  `}
`


export const TopTextMenu = styled.p`
  font-size: 20px;
  line-height: 24px;
  color: ${props => props.theme.colors.secondary};
  font-family: ${props => props.theme.font};
  padding: 12px 0;
  font-weight: 900;
`
